<template>
  <div class="addMoneyToApply">
    <div class="newsDetial-header" v-if="id">
      <div v-if="tabnum == 1">
        <div class="newsDetial-title">资金支付申请</div>
        <blank height="7"> </blank>
        <div class="card-title">
          <div class="state1" v-if="Form.state == 1">审批中</div>
          <div class="state2" v-if="Form.state == 2">已归档</div>
          <div class="state3" v-if="Form.state == 3">退回</div>
          <div class="state4" v-if="Form.state == 4">取消</div>
        </div>
      </div>
      <div v-else>
        <div class="newsDetial-title">资金支付申请审批流程</div>
        <blank height="7"> </blank>
        <a-button
          class="detial-top-btn"
          type="primary"
          icon="printer"
          v-if="Form.state == 2"
        >
          打印
        </a-button>
      </div>
      <a-tabs v-model="tabnum">
        <a-tab-pane key="1" tab="表单详情" />
        <!-- 草稿未开启审批流不展示跳转审批流按钮 -->
        <a-tab-pane key="2" tab="表单流程" v-if="Form.state > 0" />
      </a-tabs>
    </div>
    <div class="newsDetial-header" v-else>
      <div class="newsDetial-title">新建表单</div>
      <blank height="15"> </blank>
      <div class="newsDetial-abstract">
        请按照文本要求添加表单，并提交进行流程审批
      </div>
      <blank height="45"> </blank>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <div class="detial-cont-title">申请表单</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view">
        <a-descriptions layout="vertical">
          <a-descriptions-item label="部门">
            <a-tree-select
              disabled
              v-model="organizationId"
              class="w300"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              :tree-data="treeData"
              placeholder="请选择部门/单位"
              tree-default-expand-all
              :replaceFields="{
                key: 'id',
                value: 'id',
                children: 'treeList',
                title: 'organizationName'
              }"
            >
            </a-tree-select>
          </a-descriptions-item>
          <a-descriptions-item label="时间">
            <a-date-picker
              class="w300"
              v-model="Form.date"
              :valueFormat="dateFormat"
              :disabled="disabled"
            />
          </a-descriptions-item>

          <a-descriptions-item label="申请金额(元)">
            <a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.money"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <a-descriptions-item label="经办人"
            ><a-input
              class="w300"
              placeholder="请添加"
              v-model="Form.agent"
              :disabled="disabled"
            />
          </a-descriptions-item>
          <br />
          <br />
          <a-descriptions-item label="申请事由">
            <a-input
              class="w500"
              v-model="Form.title"
              type="textarea"
              :auto-size="{ minRows: 4, maxRows: 6 }"
              :disabled="disabled"
            />
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>
    <div class="detial-cont" v-if="tabnum == 1">
      <!-- 附件 -->
      <accessories-table
        v-model="updateList"
        :file="updateList"
        :disabled="disabled"
      ></accessories-table>
    </div>
    <div class="detial-cont" v-if="tabnum == 2">
      <div class="detial-cont-title">审批流程图示</div>
      <blank height="1"> </blank>
      <div class="detial-cont-view"></div>
    </div>
    <appfloor v-if="tabnum == 2"></appfloor>
    <template v-if="tabnum == 1">
      <bottomSuspension>
        <a-button :style="{ marginRight: '20px' }" @click="goback">
          返回
        </a-button>
        <!-- 表单为可编辑状态 显示提交按钮 -->
        <template>
          <div v-if="proQueryParams.isEdit === '0' ? true : false">
            <a-button
              :loading="confirmLoading && Form.draft == 1"
              type="primary"
              class="orange-btn"
              @click="preserveFn('0')"
              :style="{ marginRight: '20px' }"
            >
              保存
            </a-button>
          </div>
          <a-button
            v-if="!Form.state"
            :loading="loading && Form.draft == 1"
            type="primary"
            class="orange-btn"
            @click="preserveFn('1')"
            :style="{ marginRight: '20px' }"
          >
            保存
          </a-button>
          <a-button
            :loading="loading && Form.draft == 2"
            type="primary"
            :style="{ marginRight: '42px' }"
            @click="submitFn"
          >
            {{ Form.state > 0 ? '保存修改' : '提交' }}
          </a-button>
        </template>
        <!-- 表单正在审批状态  显示审批按钮 -->
        <a-button
          type="primary"
          :style="{ marginRight: '42px' }"
          v-if="Form.state == 1"
        >
          审批
        </a-button>
      </bottomSuspension>
    </template>
  </div>
</template>

<script>
const columns2 = [
  {
    title: '时间',
    dataIndex: 'time',
    key: 'time',
    ellipsis: true
  },
  {
    title: '责任人',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true
  },
  {
    title: '意见',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: '批示',
    dataIndex: 'age',
    key: 'age'
    // width: 80,
  }
]

const data = []
import { mapState, mapActions } from 'vuex'

import {
  updateApplicationSpecialFunds,
  ApplicationSpecialFundsDetial,
  addApplicationSpecialFunds
} from './api/api'

import AccessoriesTable from '@/components/accessories-table/index.vue'
export default {
  data() {
    return {
      loading: false,
      tabnum: '1', // 1表单页面， 2审批流页面
      Form: {},
      updateList: [],
      id: '',
      dateFormat: 'YYYY-MM-DD',
      data,
      columns2
    }
  },
  components: {
    AccessoriesTable
  },
  computed: {
    ...mapState({
      treeData: (state) => state.app.organizeList, // 组织机构树
      organizationId: (state) => state.app.organizationId // 当前用户部门id
    }),
    // 获取表单是否可编辑状态  false可编辑  true不可编辑
    disabled: function () {
      if (!this.id) {
        // id不存在  为添加  可编辑
        return false
      } else {
        if (this.Form.state == 1 || this.Form.state == 2) {
          //审批状态和归档状态  不可编辑
          return true
        } else {
          // 草稿箱或退回状态  可编辑
          return false
        }
      }
    }
  },
  created() {
    this.getorganizeListFn()
    this.id = this.$route.query.id ? this.$route.query.id : ''
    if (this.id) {
      ApplicationSpecialFundsDetial({ id: this.id }).then((res) => {
        if (res.data.code == 0) {
          this.Form = res.data.data
          this.updateList = this.Form.file
        }
      })
    }
  },
  methods: {
    ...mapActions(['getorganizeListFn']),
    goback() {
      this.$router.push('/MoneyToApply')
    },
    preserveFn(type) {
      this.Form.draft = 1
      this.saveFormFn('保存')
    },

    submitFn() {
      this.$confirm({
        title: '确定提交吗?',
        okType: 'danger',
        onOk: () => {
          this.Form.draft = 2
          this.saveFormFn('添加')
        }
      })
    },
    saveFormFn(type) {
      this.Form.file = this.updateList
      this.Form.appId = this.$route.meta.appId
      this.Form.skipPageReqFlag = '/MoneyToApplyDetial'
      this.loading = true
      if (this.id) {
        updateApplicationSpecialFunds(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success('操作成功')
            this.goback()
            this.loading = false
          } else {
            this.loading = false
          }
        })
      } else {
        addApplicationSpecialFunds(this.Form).then((res) => {
          if (res.data.code == 0) {
            this.$message.success(type + '成功')
            this.goback()
            this.loading = false
          } else {
            this.loading = false
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.addMoneyToApply {
  .newsDetial-header {
    position: relative;
    background: #fff;
    padding: 0 40px;
    .newsDetial-title {
      height: 26px;
      color: rgba(56, 56, 56, 1);
      font-size: 18px;
      line-height: 26px;
      font-weight: bold;
    }
    .newsDetial-abstract {
      color: rgba(166, 166, 166, 1);
      font-size: 14px;
      line-height: 22px;
    }
    .detial-top-btn {
      position: absolute;
      right: 87px;
      top: 0;
    }
  }
  .detial-cont {
    margin: 24px 16px;

    .detial-cont-title {
      background: #fff;
      height: 55px;
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      line-height: 55px;
      text-align: left;
      padding-left: 32px;
    }
    .detial-cont-view {
      background: #fff;
      padding: 30px;
      .accessory-btn {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MoneyToApply/detial.vue